import { render, staticRenderFns } from "./EmployeeListView.vue?vue&type=template&id=342097b8&"
import script from "./EmployeeListView.vue?vue&type=script&lang=js&"
export * from "./EmployeeListView.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeListView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VCard,VVirtualScroll})
